import { Button, Modal, NumberInput } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './EditBudgetCapModal.module.scss';
import { Props } from './EditBudgetCapModal.types';

const EditBudgetCapModal = ({ open, onClose, currentBudgetCap, onSave, isLoading }: Props) => {
  const { t } = useTranslation();
  const [value, setValue] = useState<number | ''>(currentBudgetCap ?? '');

  useEffect(() => {
    if (open) {
      setValue(currentBudgetCap ?? '');
    }
  }, [open, currentBudgetCap]);

  const handleSave = () => {
    onSave(value === '' ? null : value);
    onClose();
  };

  const handleRemove = () => {
    onSave(null);
    onClose();
  };

  return (
    <Modal
      opened={open}
      onClose={onClose}
      title={
        <div className={styles.title}>
          {t('expenses.budgetCap.modal.title', 'Budget plafond annuel')}
        </div>
      }
      withCloseButton={true}
    >
      <p className={styles.subtitle}>
        {t(
          'expenses.budgetCap.modal.subtitle',
          'Définissez un budget maximum pour suivre vos dépenses annuelles.'
        )}
      </p>

      <NumberInput
        label={t('expenses.budgetCap.modal.inputLabel', 'Montant du plafond')}
        placeholder={t('expenses.budgetCap.modal.inputPlaceholder', 'Ex: 30000')}
        value={value}
        onChange={val => setValue(val === '' ? '' : Number(val))}
        min={0}
        step={1000}
        suffix=" €"
        thousandSeparator=" "
        disabled={isLoading}
      />

      <div className={styles.buttons}>
        {currentBudgetCap && (
          <Button
            variant="filled"
            onClick={handleRemove}
            disabled={isLoading}
            className={styles.removeButton}
          >
            {t('expenses.budgetCap.modal.remove', 'Supprimer le plafond')}
          </Button>
        )}
        <Button variant="outline" onClick={onClose} disabled={isLoading}>
          {t('common.cancel', 'Annuler')}
        </Button>
        <Button onClick={handleSave} loading={isLoading}>
          {t('common.save', 'Enregistrer')}
        </Button>
      </div>
    </Modal>
  );
};

export default EditBudgetCapModal;
